import React from 'react';
import './ConfirmModal.css';

function ConfirmModal({ isOpen, title, message, confirmText, cancelText, onConfirm, onCancel, variant }) {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <div className={`confirm-modal-icon ${variant === 'danger' ? 'danger' : variant === 'warning' ? 'warning' : 'info'}`}>
          {variant === 'danger' ? '🗑️' : variant === 'warning' ? '⚠️' : '❓'}
        </div>
        <h2 className="confirm-modal-title">{title}</h2>
        {message && <p className="confirm-modal-message">{message}</p>}
        <div className="confirm-modal-actions">
          <button className="confirm-modal-cancel" onClick={onCancel}>
            {cancelText || 'Cancel'}
          </button>
          <button
            className={`confirm-modal-confirm ${variant === 'danger' ? 'danger' : ''}`}
            onClick={onConfirm}
          >
            {confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;